import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';

import { DialogConstant } from '../Constant';

import { EventService } from './event.service';

@Injectable({
    providedIn: 'root'
})
export class DialogService
{
    private progress_timer = null;

    constructor(
        private alert: AlertController,
        private event: EventService
    )
    {
    }

    async message(title, message, btn)
    {
        const dialog = await this.alert.create({
            header: title,
            message: message,
            buttons: [btn],
            backdropDismiss: false,
            mode: 'ios'
        });
        await dialog.present();
    }

    async confirm(title, message, buttons)
    {
        let dialog = await this.alert.create({
            header: title,
            message: message,
            buttons: buttons,
            backdropDismiss: false,
            mode: 'ios'
        });
        await dialog.present();
    }

    async progress(func, file_name, key)
    {
        clearTimeout(this.progress_timer);
        this.event.show_progress_empty_subject.next(false);
        this.event.show_progress_subject.next(true);

        const elm = document.getElementById('upload-progress-body');

        const iconElm = document.createElement("ion-icon");
        iconElm.setAttribute("name", `close-circle-outline`);

        const cancelElm = document.createElement("div");
        cancelElm.setAttribute("id", `upload-progress-cancel-${key}`);
        cancelElm.setAttribute("class", "upload-progress-cancel");
        cancelElm.addEventListener('click', func);
        cancelElm.appendChild(iconElm);

        const frontElm = document.createElement("div");
        frontElm.setAttribute("id", `upload-progress-front-${key}`);
        frontElm.setAttribute("class", "upload-progress-front");

        const backElm = document.createElement("div");
        backElm.setAttribute("id", `upload-progress-back-${key}`);
        backElm.setAttribute("class", "upload-progress-back");
        backElm.appendChild(frontElm);

        const maskElm = document.createElement("div");
        maskElm.setAttribute("class", "upload-progress-mask");
        maskElm.innerHTML = `${file_name}`;

        const progressElm = document.createElement("div");
        progressElm.setAttribute("id", `upload-progress-item-${key}`);
        progressElm.setAttribute("class", "upload-progress-item");
        progressElm.appendChild(backElm);
        progressElm.appendChild(maskElm);
        progressElm.appendChild(cancelElm);

        elm.appendChild(progressElm);
    }

    async progressClose(key, cnt)
    {
        const elm = document.getElementById(`upload-progress-item-${key}`);
        if (elm != null) elm.remove();

        this.event.show_progress_badge_subject.next(cnt);

        if (cnt == 0) {
            this.event.show_progress_empty_subject.next(true);
            this.progress_timer = setTimeout(() => {
                this.event.show_progress_subject.next(false);
                this.event.show_progress_empty_subject.next(false);
            }, 5000);
        }
    }

    setProgressPercent(percent, key)
    {
        const elm = document.getElementById(`upload-progress-front-${key}`);
        if (elm != null) elm.style.width = percent+'%';
    }

    close()
    {
        this.alert.dismiss​();
    }
}
